import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { components } from "@/shared/lib/api.types"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"
import type { ChildFormValues, RedeemValues } from "../children.schemas"
import { childrenKeys } from "./children.queries"

export type Invite = components["schemas"]["InviteResponse"]

export function useCreateChildMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (values: ChildFormValues) =>
      unwrap(apiClient.POST("/api/children", { body: values })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: childrenKeys.all }),
  })
}

export function useUpdateChildMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, values }: { id: string; values: ChildFormValues }) =>
      unwrap(apiClient.PUT("/api/children/{id}", { params: { path: { id } }, body: values })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: childrenKeys.all }),
  })
}

export function useLeaveChildMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      unwrap(apiClient.POST("/api/children/{id}/leave", { params: { path: { id } } })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: childrenKeys.all }),
  })
}

export function useCreateInviteMutation() {
  return useMutation({
    mutationFn: (childId: string) =>
      unwrap(apiClient.POST("/api/children/{id}/invites", { params: { path: { id: childId } } })),
  })
}

export function useRedeemInviteMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (values: RedeemValues) =>
      unwrap(apiClient.POST("/api/invites/redeem", { body: values })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: childrenKeys.all }),
  })
}
